
import { createSlice } from '@reduxjs/toolkit';
import { getAuthProps, setAuthProps, signOut } from '../../lib/authenticationLibrary';

const authData = getAuthProps();

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        isAuthenticated: (authData != null),
        user: (authData?.userName), //Set user data from cookie.
        token: (authData?.token), //Set token data from cookie.
        authData,
        isLogedin: false,
        adminUserId: (authData?.adminUserId),
        userName: (authData?.userName),
        loginName: '',
        roleId: (authData?.roleId),
        name: (authData?.name)
    },
    reducers: {
        authentication: (state, action) => {
            const { token, adminUserId, userName, roleId, name } = action.payload;
            state.isLogedin = true;
            state.loginName = userName;
            state.isAuthenticated = true;
            setAuthProps(action.payload);
            state.name = name
        },
        logout: (state) => {
            state.isLogedin = false;
            state.isAuthenticated = false;
            signOut();
        },
    },
});

export const { authentication, logout } = authSlice.actions;

export default authSlice.reducer;
